import { Channel } from 'frontendcommon-3'

export function useUsetifulEvents () {
  // Get active tour
  let currentTour
  document.addEventListener('usetiful:toursEvent', ({ detail: ev }) => {
    currentTour = ev.props?.value
  })

  // Autoscroll on step type pointer
  document.addEventListener('usetiful:tourEvent', async ({ detail: ev }) => {
    if (!currentTour) return
    if (ev.event === 'usetiful:setProgress') {
      const currentStep = currentTour.steps[currentTour.currentStepIndex]?.stepData
      if (!currentStep) return
      if (currentStep.type === 'pointer') {
        const element = await getPointerElement(currentStep)
        if (!element) return
        if (elementIsInViewport(element)) return
        const main = document.querySelector('#common-app-root > main')
        const rect = element.getBoundingClientRect()
        const mainRect = main.getBoundingClientRect()
        // Scroll to Element
        main.scrollTo(0, rect.top - mainRect.top + mainRect.height + 100, { behavior: 'smooth' })
      }
    }
  })

  function getPointerElement (step, stopPullin) {
    return new Promise((resolve) => {
      const element = document.querySelector(step.element)
      if (!element) {
        // If not found, check if micro is loaded
        const microContainer = document.querySelector('#micro > div > div')
        if (!microContainer) {
          // If else, wait for micro to load
          const channel = new Channel()
          channel.onMounted(() => {
            channel.destroy()
            getPointerElement(step).then(resolve)
          })
          return
        }
        // Start pullin since element is found
        if (stopPullin) return resolve()
        let attempts = 0
        const interval = setInterval(() => {
          if (attempts++ > 10) return clearInterval(interval)
          getPointerElement(step, true).then((el) => {
            if (el) {
              clearInterval(interval)
              resolve(el)
            }
          })
        }, 500)
      }
      // Element is found
      resolve(element)
    })
  }

  function elementIsInViewport (el) {
    const rect = el.getBoundingClientRect()
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}
